import React from 'react'
import HomePage from '../Components/HomePage/HomePage'

const HomePageView = () => {
  return (
    <div>
        <HomePage />
    </div>
  )
}

export default HomePageView